import ServiceBase from "base/baseService"

export default class IpiCstService extends ServiceBase {

    title = "CST do IPI"
    pluralTitle = "CSTs do IPI"
    url = '/cadastro/fiscal/ipicst'
    frontUrl = '/cadastro/fiscal/ipicst'
    frontUrlList = '/cadastro/fiscal/ipicstlist'
    primaryKey = 'codigo_ipicst'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Strings notNullable

        data.codigo_ipicst = data?.codigo_ipicst || ''
        data.descricao_ipicst = data?.descricao_ipicst || ''
        data.cod_tiflu_ipicst = data?.cod_tiflu_ipicst || ''

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
